(function () {
  if (!document.body) {
    document.addEventListener('DOMContentLoaded', arguments.callee);
    return;
  }

  /* =========================
     Crear barra
  ========================= */
  var bar = document.getElementById('reading-progress');
  if (!bar) {
    bar = document.createElement('div');
    bar.id = 'reading-progress';
    document.body.appendChild(bar);
  }

  /* =========================
     Estilos blindados
  ========================= */
  bar.style.cssText = `
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 0% !important;
    height: 4px !important;
    background: #3B82F6 !important;
    z-index: 2147483647 !important;
    pointer-events: none !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    transform: none !important;
    transition: width 0.1s linear !important;
  `;

  /* =========================
     Header offset (solo si aplica)
  ========================= */
  var header = document.querySelector(
    'header, .shopify-section-header, .site-header, .header'
  );

  function updateTop() {
    var t = 0;

    if (header) {
      var cs = getComputedStyle(header);
      if (cs.position === 'fixed' || cs.position === 'sticky') {
        var rect = header.getBoundingClientRect();
        if (rect.bottom > 0) {
          t = rect.bottom;
        }
      }
    }

    bar.style.top = t + 'px';
  }

  /* =========================
     Scroll progress (simple y fiable)
  ========================= */
  function onScroll() {
    updateTop();

    var scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      0;

    var docHeight = document.documentElement.scrollHeight;
    var winHeight = window.innerHeight;
    var maxScroll = docHeight - winHeight;

    var progress = maxScroll > 0 ? scrollTop / maxScroll : 0;
    progress = Math.min(Math.max(progress, 0), 1);

    bar.style.width = (progress * 100) + '%';
  }

  /* =========================
     Listeners
  ========================= */
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  if (header && 'ResizeObserver' in window) {
    new ResizeObserver(updateTop).observe(header);
  }

  if (header && 'MutationObserver' in window) {
    new MutationObserver(updateTop).observe(header, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  /* =========================
     Init
  ========================= */
  updateTop();
  onScroll();
  console.log('[reading-progress] active');
})();